export default "__VITE_ASSET__ba3dfac7__"